import React from "react";
import { SkeletonType, Wrap } from "./styles";

interface SkeletonProps {
  type: SkeletonType;
}

const Skeleton = ({ type }: SkeletonProps) => {
  return <Wrap type={type} />;
};

export default Skeleton;
